import { Box, Button, Select, Text } from "@chakra-ui/react";
import { BsChevronCompactLeft, BsChevronCompactRight } from "react-icons/bs";

type Props = {
  total: number;
  pageSize: number;
  currentPage: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (page: number) => void;
};

const Pagination = ({
  total,
  pageSize,
  currentPage,
  onPageChange,
  onPageSizeChange,
}: Props) => {
  const totalPages = Math.ceil(total / pageSize);

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleItemsPerPageChange = (e: { target: { value: string } }) => {
    onPageSizeChange(parseInt(e.target.value));
  };

  return (
    <Box
      display="flex"
      fontSize="12px"
      color={"#27314D"}
      p={4}
      justifyContent="center"
      alignItems="center"
    >
      <Select
        fontSize="12px"
        color={"#27314D"}
        size="sm"
        mr={4}
        width="100px"
        value={pageSize}
        onChange={handleItemsPerPageChange}
      >
        <option value={5}>5 条/页</option>
        <option value={10}>10 条/页</option>
        <option value={20}>20 条/页</option>
      </Select>
      <Button
        borderRadius={"2px"}
        height={"29px"}
        fontWeight={"normal"}
        fontSize="12px"
        color={"#27314D"}
        p="0 5px"
        onClick={handlePrevPage}
        disabled={currentPage === 1}
        leftIcon={<BsChevronCompactLeft />}
        mr={4}
      >
        上一页
      </Button>
      <Text mr={4}>
        第 {currentPage} 页 / 共 {totalPages} 页
      </Text>
      <Button
        borderRadius={"2px"}
        height={"29px"}
        fontWeight={"normal"}
        fontSize="12px"
        color={"#27314D"}
        p="0 5px"
        onClick={handleNextPage}
        disabled={currentPage === totalPages}
        rightIcon={<BsChevronCompactRight />}
      >
        下一页
      </Button>
    </Box>
  );
};

export default Pagination;
